import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import axios from 'axios';
import { fetchRelatedArticle } from './action-related-article';
import { contactByEmailNoIntent } from './action-contact-option';
import { requestTopicData, receiveTopicDataError } from './action-topic-data';
import { updateUserSelection } from './action-update-user-selection';
import * as types from '../constants/ActionTypes';
import { privacyRefId } from '../constants/UtilVariables';

function emailIntentSelected(topicName) {
  return (dispatch) => {
    dispatch(fetchRelatedArticle(topicName));
    dispatch(contactByEmailNoIntent());
    dispatch({
      type: types.EMAIL_INTENT_SELECTED_NO_INTENT,
      payload: true,
    });
  };
}
function receiveFormFieldsNoIntent(responseData) {
  const formFields = _get(responseData, 'formInfo.form_elements.webform_detail', []);
  const kanaCode = _get(responseData, 'formInfo.kana_code', '');
  const topicRefId = _get(responseData, 'formInfo.topicRefId', '');

  return {
    type: types.RECEIVE_FORM_FIELDS_NO_INTENT,
    payload: {
      kanaCode,
      formFields,
      topicRefId,
    },
  };
}

function receiveFormNoIntent(response) {
  const formFields = _get(response, 'formInfo.form_elements.webform_detail', []);
  return (dispatch) => {
    dispatch(contactByEmailNoIntent(formFields));
  };
}

function receiveTopicDataNoIntent(responseData) {
  const contactChannel = _get(responseData, 'formInfo.form_elements.contact_channel', {});
  return {
    type: types.RECEIVE_CONTACT_CHANNELS_NO_DATA,
    payload: contactChannel,
  };
}

function fetchFormElementsNoIntent(topicId, logout = false) {
  return (dispatch) => {
    dispatch(requestTopicData(topicId));
    axios.get(`/smarthelp/topic-data/?topic_id=${topicId}`)
      .then((response) => {
        dispatch(receiveTopicDataNoIntent(response.data));
        dispatch(receiveFormFieldsNoIntent(response.data));
        dispatch(receiveFormNoIntent(response.data));
        if (!logout) {
          dispatch(updateUserSelection('emailByPassPage'));
        }
      })
      .catch((error) => {
        if (error && error.message !== types.ERROR_TOPIC_TREE) {
          dispatch(receiveTopicDataError());
        }
      });
  };
}

// Filter Selfhelp Webform to Smarthelp Webform
function webFormFilter(rawWebform) {
  if (!Array.isArray(rawWebform)) {
    return [];
  }

  return rawWebform.map((field) => {
    const formFilterObj = {
      type: field.type,
      required: !(field.optional === 'true'),
      id: field.id || field.name,
    };

    formFilterObj.default_text = _get(field, 'Label.text')
    || _get(field, 'Content.text');

    const selectOptions = _get(field, 'Options.option');
    if (Array.isArray(selectOptions)) {
      formFilterObj.options = selectOptions.map(option => _get(option, 'label.text'));
    }

    switch (field.type) {
      case 'anchor' :
        formFilterObj.title = _get(field, 'Legend.text');
        formFilterObj.link_src = `/cgi-bin/webscr?cmd=${field.cmd}`;
        break;
      case 'custom' :
        formFilterObj.type = 'number';
        break;

      case 'text_date' :
        formFilterObj.type = 'date';
        break;

      case 'button' :
        if (field.cmd) {
          formFilterObj.type = 'anchor';
          formFilterObj.title = _get(field, 'Legend.text');
          formFilterObj.link_src = `/cgi-bin/webscr?cmd=${field.cmd}`;
        }
        break;
      default:
        break;
    }

    return formFilterObj;
  });
}

function filterWebFormResponse(options) {
  const webForms = options.webForms || null;
  const topicRefId = `GROP_${options.topicRefId}`;
  if (_isEmpty(webForms)) {
    return null;
  }

  const formsDetail = _get(webForms, 'form.fields.field', []);

  const response = {
    formInfo: {
      topicRefId,
      kana_code: _get(webForms, 'kana.inumtemplate'),
      form_elements: {
        webform_detail: webFormFilter(formsDetail),
      },
    },
  };
  return response;
}

// Filter privacy Email form for logout group markets
function filterPrivacyEmailForm(options) {
  const webForms = options.webForms || null;
  if (_isEmpty(webForms)) {
    return null;
  }
  const formsDetail = _get(webForms, 'form.fields.field', []);
  return {
    formInfo: {
      topicRefId: options.topicRefId,
      kana_code: privacyRefId, // Hardcode the topic ref id
      form_elements: {
        webform_detail: webFormFilter(formsDetail),
      },
    },
  };
}

// Get webform after users making topic selection in the emailByPassPage
function getHardCodeTopicWebForm(options) {
  return (dispatch) => {
    const response = filterWebFormResponse(options);

    if (response) {
      dispatch(receiveTopicDataNoIntent(response));
      dispatch(receiveFormFieldsNoIntent(response));
      dispatch(receiveFormNoIntent(response));
      dispatch(updateUserSelection('emailByPassPage'));
    } else {
      dispatch(receiveTopicDataError());
    }
  };
}

// Get privacy email webform for group markets
function getPrivacyHardCodeForm(options) {
  return (dispatch) => {
    const response = filterPrivacyEmailForm(options);

    if (response) {
      dispatch(receiveTopicDataNoIntent(response));
      dispatch(receiveFormFieldsNoIntent(response));
      dispatch(receiveFormNoIntent(response));
    } else {
      dispatch(receiveTopicDataError());
    }
  };
}

function accessLogoutEmail() {
  return { type: types.ACCESS_LOGOUT_EMAIL };
}

module.exports = {
  emailIntentSelected,
  fetchFormElementsNoIntent,
  getHardCodeTopicWebForm,
  getPrivacyHardCodeForm,
  accessLogoutEmail,
};
